module.exports = __webpack_public_path__ + "img/alchemy.4587a2fe.png";